<template>
    <dropdown-menu
        class="pointer-events-auto sm:flex"
        :position="position"
        :tooltip="t('ramp.about')"
        :tooltipPlacement="position"
        trigger-class="text-gray-500 hover:text-white"
        v-focus-item
    >
        <template #header>
            <div class="flex">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    class="fill-current w-20 h-20"
                    :aria-label="t('ramp.about.open')"
                >
                    <path
                        d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"
                    />
                </svg>
            </div>
        </template>
        <template v-slot:default="scope">
            <div class="about-ramp-dropdown pointer-events-auto bg-white rounded w-256 h-50">
                <div>
                    <button
                        class="absolute left-5 top-5 text-gray-500 hover:text-black focus:text-black p-8"
                        @click="reloadRamp"
                        :aria-label="t('ramp.reload')"
                        :content="t('ramp.reload')"
                        v-tippy="{
                            placement: 'bottom-start',
                            theme: 'ramp4',
                            animation: 'scale'
                        }"
                    >
                        <svg class="fill-current w-16 h-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path
                                d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
                            ></path>
                        </svg>
                    </button>
                    <h4 class="pb-8 pt-1 border-b border-gray-600 mb-10">
                        {{ t('ramp.about') }}
                    </h4>
                    <div class="absolute right-5 top-5">
                        <close @click="scope.close"></close>
                    </div>

                    <div class="select-text">
                        <div>
                            <span class="font-bold cursor-text">
                                {{ versionString }}
                            </span>
                            <span class="text-sm cursor-text"> [{{ versionHash }}] </span>
                        </div>
                        <div>
                            <span class="font-bold cursor-text">{{ buildDate[0] }}</span>
                            <span class="ml-5 cursor-text">{{ buildDate[1] }}</span>
                        </div>
                        <div class="mt-5">
                            <a
                                class="text-sm underline text-blue-600"
                                href="https://github.com/ramp4-pcar4/ramp4-pcar4"
                                target="_blank"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    class="inline-block fill-black w-16 h-16 mb-4"
                                >
                                    <path
                                        d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"
                                    />
                                </svg>
                                ramp4-pcar4
                            </a>
                        </div>
                        <div class="mt-5">
                            <a class="text-sm underline text-blue-600" :href="t('ramp.about.esriLink')" target="_blank">
                                <svg
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="inline-block fill-black w-16 h-16 mb-4"
                                >
                                    <path
                                        d="M11.64.003C10.057.04 8.595.448 7.103 1.065c-2.07.873-4.706 2.881-6.312 6.67-.375 1.057-1.878 6.091.792 10.413 2.167 3.507 4.957 5.177 8.371 5.654 3.407.475 5.255.064 7.41-.893 5.039-2.236 8.887-10.634 5.038-16.72-1.519-2.81-5.498-5.274-9.855-5.084v.002c-1.03-.032-1.637.102-2.246.22-.182-.047-.525.003-.545.4 0 .213.069.38.204.477s1.264.93 2.094 1.813c-.398.044-.83.116-1.274.208-.495-1.07-2.086-.097-3.144-.055-.123.007-.242.024-.365.03-.116-.894-.2-1.821-.178-2.473C8.464.951 11.115.378 12.915.35l.315-.008c.264-.003.285-.212.036-.246q-.838-.114-1.627-.093m-.193 1.53c3.912-.017 7.35 1.641 8.925 3.57-.56-.291-1.767-.707-2.258-.816-.265-.27-.599-.49-.888-.676-.229-.146-.514-.092-.396.163.045.1.22.267.362.435-.835-.23-3.055-.407-4.111-.31-.69-.775-1.477-1.716-2.423-2.34q.396-.024.79-.026m-4.856.426c-.013.339.074 1.328.186 2.282q-.725.072-1.433.177A10.2 10.2 0 0 0 2.707 7.88c-.1-.892-.152-1.635-.113-2.092C3.705 4.231 5.214 2.715 6.59 1.96m8.418 2.65c.488.016.988.051 1.466.1-.859.307-1.237 1.062-1.658 1.662-.008.013-.024.023-.034.034a20 20 0 0 0-1.165-1.787c.426-.025.903-.027 1.391-.01m-2.375.12a13.3 13.3 0 0 1 1.48 2.153c-.681.33-1.59.582-1.96 1.11-.153.22-.19.519-.196.842a20 20 0 0 0-3.283 1.089 35 35 0 0 1-.951-3.253c1.097-1.048 2.38-1.217 2.91-1.628a15 15 0 0 1 2-.313m6.89.634c.45.171 1.029.408 1.486.657.347.437 1.34 1.418 1.871 4.165.478 2.474-.05 4.354-.212 4.898l-.163.64a15 15 0 0 1-.705 1.882c.077-.561.145-2.019.125-2.312.136.042.425-.122.473-.286.048-.165-.477-.42-.477-.42a18 18 0 0 0-.145-2.286c.12-.195.242-.383.367-.555a10 10 0 0 0-.157-1.333c.106.035.202.062.273.063.24.003.24-.161.163-.253-.049-.059-.278-.2-.545-.355a10.2 10.2 0 0 0-2.354-4.505M1.869 7.005s.051.896.095 1.55c0 0-.662.751-1 1.347.135-1.221.423-1.85.905-2.897m5.352.232c.198 1 .436 1.829.751 2.978-1.187.524-3.286 1.818-4.213 2.516-.168-.425-.343-1.028-.5-1.647.212-.624.643-1.06 1.25-1.121 1.04-.104 1.93-1.652 2.664-2.665.016-.023.033-.04.048-.06M2.07 9.478l.014.111a10.2 10.2 0 0 0-.34 2.294c.314.33.683.88 1.09 1.446-.262.195-.767.543-.886.628-.347.247-.342.636-.095.858.137.122.417.07.52-.01.303-.242.555-.433.902-.65.127.332.247.632.363.918-.148.16-.253.37-.288.677-.115.992.828 1.77 1.623 1.997.03.01.05.013.079.02.042.064.08.124.125.19a5 5 0 0 0-.888.898c-.112.146-.237.365-.136.408.104.042.454 0 .61-.028.395-.077.699-.514.971-.675.328.452.861 1.032 1.416 1.591.024.102.046.21.074.3.106.34.25.679.42 1.01.4.187.815.34 1.24.475a7 7 0 0 0-.527.61c-3.426-1.073-5.963-3.96-6.869-6.988a14.8 14.8 0 0 1-.551-5.48c.047.01.157.061.32.016.115-.079.524-.363.813-.616m9.891.182c-.006.282-.037.55-.153.765-.166.31-.09 1.209.113 1.503.639.93 1.701.412 2.5.747.366.153.61.407.815.71a13.6 13.6 0 0 0-4.832 1.196c-.781-1.66-1.455-3.83-1.455-3.83v-.003A16.4 16.4 0 0 1 11.96 9.66m-3.757 1.418c.423 1.262 1.028 2.95 1.447 3.852l-.183.093a35 35 0 0 0-2.757-.66c-.842-.173-.873-.128-1.82.147q-.203.057-.392.113a31 31 0 0 1-.376-1.018 23 23 0 0 1 4.08-2.527m13.136 1.976c.051.463.087.916.109 1.325a8 8 0 0 0-.656-.249c.166-.344.35-.712.547-1.076m-5.611 1.175c.16.28.34.56.585.81.641.655-.372 1.595-.08 3.449h-.003c-.3.032-.597.069-.86.109-.652.102-1.492.322-2.273.613-.449-.713-1.65-2.448-2.258-3.757 1.221-.6 2.926-1.104 4.889-1.224m4.755.556c.354.1.686.207.975.325.036.521.035 2.31-.067 3.184a3.5 3.5 0 0 1-.537.757 8 8 0 0 0-1.076-.32c.066-.079.139-.153.204-.235.227-1.52-.286-2.007.355-3.398zm-9.67 2.378c.482.811 1.057 1.693 1.502 2.383-.693.336-1.499.856-2.26 1.427.052-.878.07-1.746.247-2.209.248-.647.44-1.128.511-1.6m8.545 2.053c.463.054.926.131 1.208.202-.627.793-1.492 1.454-2.413 2.028.02-.345.033-.78.044-1.182.412-.32.802-.668 1.161-1.048m-2.952.01a6.5 6.5 0 0 0 .378.927c.16.324.347.56.549.721.072-.045.139-.096.21-.143-.005.355-.015.716-.036 1.064-.243.16-1.41.688-1.868.836a20 20 0 0 1-2.066-2.71c.715-.3 1.815-.567 2.833-.694m-3.628 1.002c.34.533 1.46 2.123 1.91 2.635-.815.142-1.956.249-2.86.21 0 0-1.356-.9-1.7-1.246.68-.565 1.781-1.235 2.65-1.599m-3.156 2.053c.396.263.82.564 1.157.758-.52-.06-1.131-.074-1.585-.229.131-.171.265-.383.428-.529"
                                    />
                                </svg>
                                {{ t('ramp.about.esriLegal') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </dropdown-menu>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import { version } from '@/main';
import { useI18n } from 'vue-i18n';
import type { InstanceAPI } from '@/api';

const { t } = useI18n();
const iApi = inject('iApi') as InstanceAPI;

defineProps({
    position: {
        type: String,
        default: 'top-start'
    }
});

/**
 * Reload the entire RAMP config
 */
const reloadRamp = () => {
    iApi.reload();
};

/**
 * Get RAMP's version string
 */
const versionString = computed<string>(() => {
    return `${version.major}.${version.minor}.${version.patch}`;
});

/**
 * Get RAMP build version hash
 */
const versionHash = computed<string>(() => {
    return version.hash.slice(0, 9);
});

/**
 * Get RAMP build date
 */
const buildDate = computed(() => {
    const timestamp = new Date(version.timestamp);
    if (isNaN(timestamp.getTime())) {
        // this appears to be broken in dev serve mode (but not always).
        // likely the vite `git log -1 --format=%cd` command isnt working in that context
        return ['dev mode', 'no date'];
    } else {
        const padZero = (num: number): string => {
            if (num < 10) {
                return '0' + num.toString();
            } else {
                return num.toString();
            }
        };
        return [
            `${timestamp.getFullYear()}-${timestamp.getMonth() + 1}-${timestamp.getDate()}`,
            `${timestamp.getHours()}:${padZero(timestamp.getMinutes())}:${padZero(timestamp.getSeconds())}`
        ];
    }
});
</script>

<style lang="scss" scoped>
.about-ramp-dropdown {
    padding: 0 !important;

    &:hover {
        background-color: #fff !important;
    }
}
</style>
